'use client';

import { useTranslations } from 'next-intl';
import { SITE } from '@/app/constants';
import { useDoubleFestivalCampaign } from '@/app/hooks';

export const DoubleFestivalPricing = () => {
  const t = useTranslations(SITE === 'china' ? 'doubleFestival' : 'doubleFestival.global');
  const visible = useDoubleFestivalCampaign();
  if (!visible) return null;
  return (
    <section aria-label={t('title')} className="w-full overflow-hidden rounded-16">
      <picture>
        <source
          media="(max-width: 767px)"
          srcSet={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/Frame%201686559285-d59e049f.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/Frame%201686559286-d448bb15.webp'
          }
          width={1140}
          height={144}
        />
        <img
          src={
            SITE === 'china'
              ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/china-pricing-banner-1ee1ef28.webp'
              : 'https://image01.cf.vidu.studio/vidu/media-asset/global-pricing-banner-603b362a.webp'
          }
          width={2671}
          height={240}
          alt={t('headline')}
          className="block h-auto w-full"
        />
      </picture>
    </section>
  );
};
